import gql from 'graphql-tag';

export default gql`
mutation AddEndpointTrack(
        $uuid: String!,
        $name: String!,
        $type: String,
        ) {
    addTrack(input:{
        uuidEndpoint: $uuid,
        name: $name,
        type: $type,
    }) {
        __typename
        uuid
        track
        signedUrl
    }
}
`;
